export default __webpack_public_path__ + "static/media/frg--orchard-parklands.db29df51.png";